import React, { useEffect, useState, useContext } from "react";
import { Carousel } from "react-responsive-carousel";
import "./mainPageCarousel.css";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { db } from "../../../../config/firebase_config";
import { ref, get } from "firebase/database";
import RestBanners from "../../../../models/Restaurent_banners";
import RestaurentContext from "../../../../context/rest_context";
import { CarouselSkeleton } from "../../../../components/skeletons/skeletons.jsx";

const MainPageCarousel = ({ restID }) => {
    // const { restBanners, setRestBanners } = useContext(RestaurentContext);
    const [restBanners, setRestBanners] = useState([]);

    useEffect(() => {
        console.log({ restID });
        const fetchData = async () => {
            try {
                const databaseRef = ref(db, `${restID}_Banners`);
                const snapshot = await get(databaseRef);
                let restBanners = [];
                console.log({ snapshot }, snapshot.exists());
                if (snapshot.exists()) {
                    const data = snapshot.val();
                    console.log({ data });
                    Object.values(data).forEach((value) => {
                        restBanners.push(new RestBanners(value));
                    });
                    console.log(restBanners);
                    setRestBanners([...restBanners]);
                } else {
                    // Set dummy banners when no data exists
                    const dummyBanners = [
                        new RestBanners({
                            imageUrl: "/1.jpg",
                        }),
                        new RestBanners({
                            imageUrl: "/2.jpg",
                        }),
                        new RestBanners({
                            imageUrl: "/3.jpg",
                        }),
                        new RestBanners({
                            imageUrl: "/4.jpg",
                        }),
                        new RestBanners({
                            imageUrl: "/5.jpg",
                        }),
                    ];
                    setRestBanners(dummyBanners);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                // Set dummy banners on error as well
                // const dummyBanners = [
                //   new RestBanners({
                //     imageUrl:
                //       "https://firebasestorage.googleapis.com/v0/b/thediningapp-a976c.appspot.com/o/Images%2Ff83cf245-41a7-4cc2-9178-b3253965154e?alt=media&token=7fd3919c-8c7a-42be-aaa4-4f579aebef5e",
                //   }),
                //   new RestBanners({
                //     imageUrl:
                //       "https://firebasestorage.googleapis.com/v0/b/thediningapp-a976c.appspot.com/o/Images%2Ff83cf245-41a7-4cc2-9178-b3253965154e?alt=media&token=7fd3919c-8c7a-42be-aaa4-4f579aebef5e",
                //   }),
                //   new RestBanners({
                //     imageUrl:
                //       "https://firebasestorage.googleapis.com/v0/b/thediningapp-a976c.appspot.com/o/Images%2Ff83cf245-41a7-4cc2-9178-b3253965154e?alt=media&token=7fd3919c-8c7a-42be-aaa4-4f579aebef5e",
                //   }),
                // ];
                // setRestBanners(dummyBanners);
            }
        };

        fetchData();
    }, [restID]);

    return restBanners.length == 0 ? (
        <CarouselSkeleton />
    ) : (
        <div className="rest-carousel-main">
            <Carousel
                className="rest-carousel-container"
                autoPlay={true}
                interval={4000}
                showThumbs={false}
                infiniteLoop={true}
                showArrows={false}
                showStatus={false}
                showIndicators={true}
                stopOnHover={true}
                transitionTime={600}
                swipeable={true}
            // showIndicators={false}
            >
                {restBanners.map((banner, index) => {
                    return (
                        <div className="rest-carousel" key={index}>
                            <img
                                src={banner.imageUrl}
                                alt={`Banner ${index + 1}`}
                                loading="lazy"
                            />
                        </div>
                    );
                })}
            </Carousel>
        </div>
    );
};

export default MainPageCarousel;
